import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'receipt-cancelled-transaction-card:label': {
    id: 'receipt-cancelled-transaction-card:label',
    defaultMessage: 'Canceled Order',
    description: 'Label for cancelled transaction card (Activate Transaction Receipt)',
  },
});
